











































import Vue, { PropType } from 'vue';

interface DataType {
  isOpened: boolean;
}

export default Vue.extend({
  name: 'GLayoutBox',
  data(): DataType {
    return {
      isOpened: false,
    };
  },
  props: {
    title: {
      type: String as PropType<string>,
      default: '',
    },
    opened: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    hasAccordion: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    onSpExpansion: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  methods: {
    onClick() {
      if (this.hasAccordion) {
        this.isOpened = !this.isOpened;
      }
    },
  },
  mounted() {
    if (!this.hasAccordion) {
      this.isOpened = true;
    } else {
      this.isOpened = this.opened;
    }
  },
});
